import PagedElements from '@/models/paged/pagedelements';
import PrinterListViewModel from '@/models/view/printerlistviewmodel';

export default class PagedPrinters extends PagedElements<PrinterListViewModel> {
    constructor(init?: Partial<PagedPrinters>) {
        super(init);
    }
}
